export { default as ProviderCell } from './ProviderCell'
export { default as LocationsCell } from './LocationsCell'
export { default as CheckCell } from './CheckCell'
export { default as SlotsCell } from './SlotsCell'
export { default as SlotsPriceCell } from './SlotsPriceCell'
export { default as ModsCell } from './ModsCell'
export { default as CheckListCell } from './CheckListCell'
export { default as PlatformsCell } from './PlatformsCell'
export { default as CustomerSupportCell } from './CustomerSupportCell'
export { default as RatingCell } from './RatingCell'
export { default as ControlPanelCell } from './ControlPanelCell'



// WEBPACK FOOTER //
// /opt/build/repo/src/components/cells/index.js